import { Button, LoadingAnimation, Text } from '@/components'
import { useAppSelector } from '@/hooks'
import { selectInProgressUnenrollment } from '@/reducers/inProgressUtilityProgramUnenrollments'

import { useUnenrollmentRouteContext } from '..'
import {
  VehicleUnenrollmentReasonSection,
  ThermostatUnenrollmentReasonSection,
  ChargerUnenrollmentReasonSection,
  BatteryUnenrollmentReasonSection,
  ProgramUnenrollmentReasonSection,
} from './components/DeviceUnenrollmentReasonSection'
import Separator from '@/app/components/Separator/Separator'
import useViewModel from './useUnenrollReasonViewModel'

function SectionSeparator() {
  return <Separator className="my-8" />
}

function UnenrollReasonContent(props: Parameters<typeof useViewModel>[0]) {
  const {
    vehicles,
    thermostats,
    chargers,
    energySystems,
    utilityProgram,
    isLoadingOrIdle,
    makeDeviceOnSelectInputChange,
    onSubmit,
    incentivesExist,
    selectedOptions,
  } = useViewModel(props)

  if (isLoadingOrIdle) {
    return <LoadingAnimation type="falling" centered />
  }

  return (
    <div className="flex flex-col h-full">
      <Text variant="h3" className="mb-8">
        Reason(s) for unenrollment?<span className="text-red-500">*</span>
      </Text>

      {vehicles.length > 0 && (
        <>
          <VehicleUnenrollmentReasonSection
            vehicles={vehicles}
            onChange={makeDeviceOnSelectInputChange('vehicle')}
          />
          <SectionSeparator />
        </>
      )}
      {thermostats.length > 0 && (
        <>
          <ThermostatUnenrollmentReasonSection
            thermostats={thermostats}
            onChange={makeDeviceOnSelectInputChange('thermostat')}
          />
          <SectionSeparator />
        </>
      )}
      {chargers.length > 0 && (
        <>
          <ChargerUnenrollmentReasonSection
            chargers={chargers}
            onChange={makeDeviceOnSelectInputChange('charger')}
          />
          <SectionSeparator />
        </>
      )}
      {energySystems.length > 0 && (
        <>
          <BatteryUnenrollmentReasonSection
            energySystems={energySystems}
            onChange={makeDeviceOnSelectInputChange('energySystem')}
          />
          <SectionSeparator />
        </>
      )}
      <ProgramUnenrollmentReasonSection
        utilityProgram={utilityProgram}
        incentivesExist={incentivesExist}
        onChange={makeDeviceOnSelectInputChange('profile')}
      />
      <span className="flex-auto"></span>
      <Button
        variant="primary"
        id="unenroll-reason-next"
        disabled={!selectedOptions || selectedOptions.length === 0}
        onClick={onSubmit}
        className="mt-8"
      >
        Continue
      </Button>
    </div>
  )
}

export default function UnenrollReason() {
  const { utilityProgram } = useUnenrollmentRouteContext()
  const inProgressUnenrollment = useAppSelector(
    selectInProgressUnenrollment(utilityProgram.id),
  )

  if (!inProgressUnenrollment) {
    return null
  }

  return (
    <UnenrollReasonContent
      inProgressUnenrollment={inProgressUnenrollment}
      utilityProgram={utilityProgram}
    />
  )
}
